import React from "react";
import Header from "../../app/header";
import Thanks from "./components/standard_thanks";
import Footer from "../../app/footer";
import styles from '../../assets/styles/form.module.scss'

const Complete = (props) => {

  return (
    <>
      <div className={styles.container}>
        <Header />
        <Thanks />
        <Footer />
      </div>
    </>
  );
}

export default Complete;
